import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBox, faUser, faMapMarkerAlt, faGripVertical } from '@fortawesome/free-solid-svg-icons';

/**
 * TaskCard - Figma task route card component matching DailyTasks_01_RoutOpen.png
 */
export function TaskCard({ 
  index,
  number,
  title,
  name = 'Cliente',
  address = 'Dirección de entrega', 
  trackingNumber,
  tracking,
  time = '10:30', 
  timeLabel = 'AM',
  isActive,
  active = false,
  avatar,
  draggable = false,
  onClick,
  className = '',
}) {
  const displayNum = number !== undefined ? number : (index !== undefined ? index : 1);
  const displayName = title || name || 'Cliente';
  const displayTracking = tracking || trackingNumber;
  const isCardActive = active || isActive || false;

  return (
    <div 
      onClick={onClick}
      className={`bry-task-card ${isCardActive ? 'active' : ''} ${className}`.trim()}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (e) => e.key === 'Enter' && onClick() : undefined}
    >
      {draggable && (
        <div className="bry-task-drag text-gray-500 mr-1">
          <FontAwesomeIcon icon={faGripVertical} />
        </div>
      )}

      {/* Circle Badge Number (28px Figma spec) */}
      <div className={`bry-task-number ${!isCardActive ? 'outline' : ''}`}>
        {displayNum}
      </div>

      {/* Customer Avatar Circle (40px) */}
      {avatar ? (
        <img src={avatar} alt={displayName} className="bry-task-avatar" loading="lazy" />
      ) : (
        <div className="bry-task-avatar flex items-center justify-center bg-gray-800 text-gray-400">
          <FontAwesomeIcon icon={faUser} className="text-xs" />
        </div>
      )}

      {/* Info Stack */}
      <div className="bry-task-info min-w-0 flex-1">
        <h4 className="bry-task-name truncate">{displayName}</h4>
        <p className="bry-task-address truncate">
          <FontAwesomeIcon icon={faMapMarkerAlt} className="mr-1 text-[10px] text-gray-500" />
          {address}
        </p>
        {displayTracking && (
          <div className="bry-task-tracking">
            <FontAwesomeIcon icon={faBox} className="text-[10px]" />
            <span>Tracking #{displayTracking}</span>
          </div>
        )}
      </div>

      {/* Right Column: Time */}
      <div className="text-right shrink-0">
        <div className="bry-task-time">{time}</div>
        {timeLabel && <div className="bry-task-time-label">{timeLabel}</div>}
      </div>
    </div>
  );
}

export default TaskCard;

